import { render, staticRenderFns } from "./ProviderContacts.vue?vue&type=template&id=6e1faa7a&"
import script from "./ProviderContacts.vue?vue&type=script&lang=js&"
export * from "./ProviderContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports